import { Temperature } from './Temperature';

export function measureFactory(
  measureList: Array<any>,
  dateList: Array<Date>,
  data: any,
  measureType: string
) {
  switch (measureType) {
    case 'temperature':
      return new Temperature(
        measureList,
        dateList,
        data.assetId,
        data.asset.type,
        data.asset.reference
      );
  }
}
